import React, { useCallback, useState } from "react";
import clsx from "clsx";
import ModalAutocomplete, { ModalAutocompleteProps } from "./ModalAutocomplete";
import { useAutocompleteSearch } from "components/FindYourCruise/Components/Autocomplete/useAutocompleteSearch";
import { DEFAULT_SEPARATOR } from "components/FindYourCruise/Components/RefinementListFilter/label";
import * as styles from "./OpenModalAutocompleteButton.module.scss";
import { useLingui } from "@lingui/react/macro";
import { PublicFacetSource } from "components/FindYourCruise/Components/Autocomplete/buildSources";

type Props = ModalAutocompleteProps & {
  label: string;
  emptyPlaceholder?: string;
  autocompleteEnabledSources?: PublicFacetSource[];
};

const OpenModalAutocompleteButton: React.FC<Props> = (props) => {
  const { t } = useLingui();
  const [modalIsMounted, setModalIsMounted] = useState(false);
  const [modalIsVisible, setModalIsVisible] = useState(false);
  const search = useAutocompleteSearch();

  const hasSelection = search.tags.length > 0;
  const label = props.label;
  const valuesLabel = search.tags.map((x) => x.label).join(DEFAULT_SEPARATOR);

  const openModal = useCallback(() => {
    setModalIsMounted(true);
    setModalIsVisible(true);
  }, []);

  const emptyPlaceholder = props.emptyPlaceholder || label;

  return (
    <React.Fragment>
      <button
        className={clsx(styles.labelsContainer, {
          [styles.withSelection]: hasSelection
        })}
        onClick={openModal}
      >
        <label className={styles.label}>
          {hasSelection ? label : emptyPlaceholder}
        </label>
        <div className={styles.valuesLabel}>{valuesLabel}</div>
      </button>

      {modalIsMounted && (
        <ModalAutocomplete
          {...props}
          title={t`Where to go?`}
          modal={{
            onRequestClose: () => setModalIsVisible(false)
          }}
          isVisible={modalIsVisible}
          dataContentName="modal_filters_where"
        />
      )}
    </React.Fragment>
  );
};

export default OpenModalAutocompleteButton;
